import { render, staticRenderFns } from "./PurchasePriceHistory.vue?vue&type=template&id=01c0f9ef&scoped=true"
import script from "./PurchasePriceHistory.vue?vue&type=script&lang=js"
export * from "./PurchasePriceHistory.vue?vue&type=script&lang=js"
import style0 from "./PurchasePriceHistory.vue?vue&type=style&index=0&id=01c0f9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0f9ef",
  null
  
)

export default component.exports